import React from "react";
import "../style/page/Webinars.css";
import { useWebinarsContent } from "../hooks/useWebinarsContent";
import WebinarsTable from "../component/WebinarsTable";

function Webinars() {
  const { title, description, metaTitle, items, headerTexts } = useWebinarsContent();

  React.useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  return (
    <main className="main-content webinars">
      <h4 className="page-title">{title}</h4>

      <p className="description" dangerouslySetInnerHTML={{ __html: description }} />

      <WebinarsTable items={items} headerTexts={headerTexts} />
    </main>
  );
}

export default Webinars;
